import { useQuery } from '@tanstack/react-query';
import fetch from './fetch';

/**
 * @param {string} stockCode
 */
function usePriceIndicative(stockCode) {
  const { cb, key } = fetch(stockCode);
  const { data, isSuccess, refetch } = useQuery(key, cb, {
    enabled: !!stockCode,
    staleTime: Infinity,
  });

  const isFullCallAuction = data?.cross_type === 'C' || data?.cross_type === 'I';
  const isPreOpening = data?.status === 'PRE_OPENING' && data?.cross_type === 'P';
  const isPreClosing = data?.status === 'PRE_CLOSING' && data?.cross_type === 'K';

  return { data, isSuccess, refetch, isPreOpening, isPreClosing, isFullCallAuction };
}

export default {
  usePriceIndicative,
};
